import { render, staticRenderFns } from "./SalesIndex.vue?vue&type=template&id=79f9d868&scoped=true&"
import script from "./SalesIndex.vue?vue&type=script&lang=js&"
export * from "./SalesIndex.vue?vue&type=script&lang=js&"
import style0 from "./SalesIndex.vue?vue&type=style&index=0&id=79f9d868&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f9d868",
  null
  
)

export default component.exports